module.exports = __webpack_public_path__ + "img/a1.fa4b59d5.png";